/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmrClusterDefinitionSpotSpecification { 
    /**
     * The spot provisioning timeout period in minutes. If Spot instances are not provisioned within this time period, the                   TimeOutAction is taken. Minimum value is 5 and maximum value is 1440. The timeout applies only during initial provisioning, when the cluster                   is first created                
     */
    timeoutDurationMinutes?: number;
    /**
     * The action to take when TargetSpotCapacity has not been fulfilled when the TimeoutDurationMinutes has expired. Spot instances                   are not uprovisioned within the Spot provisioining timeout. Valid values are TERMINATE_CLUSTER and SWITCH_TO_ON_DEMAND to fulfill the                   remaining capacity                
     */
    timeoutAction?: string;
    /**
     * The defined duration for Spot instances (also known as Spot blocks) in minutes. When specified, the Spot instance does not                   terminate before the defined duration expires, and defined duration pricing for Spot instances applies. Valid values are 60, 120, 180, 240,                   300, or 360. The duration period starts as soon as a Spot instance receives its instance ID. At the end of the duration, Amazon EC2 marks the                   Spot instance for termination and provides a Spot instance termination notice, which gives the instance a two-minute warning before it                   terminates                
     */
    blockDurationMinutes?: number;
    /**
     * Specifies the strategy to use in launching Spot instance fleets. Currently, the only option is \"capacity-optimized\" (the                   default), which launches instances from Spot instance pools with optimal capacity for the number of instances that are launching                
     */
    allocationStrategy?: string;
}
